import { Box } from "@mui/material";
import Image from "next/image";
import React, { useState } from "react";

interface ItineraryMapImageProps {
  imgSrc?: string;
  imgAlt?: string;
}

const ItineraryMapImage = ({ imgSrc, imgAlt }: ItineraryMapImageProps) => {
  const [isImageLoading, setIsImageLoading] = useState(true);

  const handleImageLoad = () => {
    setIsImageLoading(false);
  };

  return imgSrc ? (
    <Box
      data-testid="itinerary-map-section"
      sx={{
        width: "100%",
        maxWidth: {xs: "none", md: "82rem" },
        height: "auto",
        position: "relative"
      }}
    >
      <Image
        data-testid="itinerary-map-image"
        src={imgSrc}
        alt={imgAlt || "itinerary map image"}
        width={820}
        height={486}
        onLoad={handleImageLoad}
        style={{
          width: "100%",
          height: "auto",
          borderRadius: "2rem",
          opacity: isImageLoading ? 0 : 1,
          transition: "opacity 0.3s ease-in-out"
        }}
      />
    </Box>
  ) : null;
};

export default ItineraryMapImage;
